"use client";

import { Core } from "@faire/design-tokens";
import { legacyIconCls } from "@faire/web/slate/utils/tracking";
import React from "react";

import { createSVGIcon } from "../util";

/** @deprecated use `@faire/slate/icons/Sprout` instead (legacy Slate foundation icons cannot be deleted from code even if unused in frontend because they may be referenced to in Builder.io page data) */
export const Sprout = createSVGIcon(
  <>
    <path
      d="M20.381 9.24513C18.9341 10.5034 16.661 10.2908 15.4747 8.78228C15.1941 8.41836 14.9894 8.00182 14.8727 7.55735C14.7561 7.11287 14.7298 6.64951 14.7955 6.1947C14.8612 5.73989 15.0176 5.3029 15.2552 4.90962C15.4929 4.51633 15.8071 4.17476 16.1792 3.90513C17.6432 2.74799 22.2855 3.42856 22.2855 3.42856C22.2855 3.42856 21.8604 8.08799 20.381 9.24513Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.09622 12.1252C5.40247 12.3864 5.75802 12.5835 6.14182 12.7048C6.52562 12.8261 6.92987 12.8692 7.33061 12.8315C7.73136 12.7938 8.12046 12.676 8.47488 12.4852C8.82929 12.2944 9.14182 12.0344 9.39394 11.7206C10.4311 10.4006 10.1311 8.40859 8.77679 7.44859C7.49279 6.43544 3.42822 7.03202 3.42822 7.03202C3.42822 7.03202 3.80022 11.112 5.09622 12.1252Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M0.856934 20.5714C0.856934 20.5714 4.28551 17.1428 11.9998 17.1428C19.7141 17.1428 23.1426 20.5714 23.1426 20.5714"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.6323 8.97595L15.4043 9.18852C13.69 10.9028 12.1643 14.8525 11.9997 17.1428C11.9997 14.4291 11.4769 13.224 9.56544 11.6914L9.48145 11.6108"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>,
  "Sprout",
  {
    color: Core.icon.default,
    fill: "none",
    viewBox: "0 0 24 24",
    className: legacyIconCls(),
  } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
